export default __webpack_public_path__ + "static/media/ironman.a0971c49.jpg";